/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Button,
  Flex,
  Group,
  Modal,
  Select,
  Text,
  Textarea,
  TextInput
} from "@mantine/core";
import { generateClient, GraphQLQuery } from "aws-amplify/api";
import { useEffect, useRef, useState } from "react";
import {
  DeleteTemplateFieldInput,
  DeleteTemplateFieldMutation,
  DeleteTemplateFieldMutationVariables,
  UpdateTemplateFieldInput,
  UpdateTemplateFieldMutation,
  UpdateTemplateFieldMutationVariables
} from "../../../API";
import {
  deleteTemplateField,
  updateTemplateField
} from "../../../graphql/mutations";
const client = generateClient();

type editFieldTemplateProps = {
  modalOpened: boolean;
  setModalOpened: (value: boolean) => void;
  template: any;
  field: any;
  // handleConfirmDeleteOption: (data: DeleteOptionProps) => void;
  fetchTemplate: (templateId: string) => void;
};

const EditFieldTemplateModal = (props: editFieldTemplateProps) => {
  const { modalOpened, setModalOpened, fetchTemplate, template, field } = props;
  const [errorMsg, setErrorMsg] = useState("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [sections, setSections] = useState();
  const [sectionId, setSectionId] = useState<any>();
  const [subSections, setSubsections] = useState<any>();
  const [subSectionId, setSubSectionId] = useState<any>();
  const [fieldName, setFieldName] = useState("");
  const [fieldValue, setFieldValue] = useState("");
  const defaultValueRef = useRef(null);

  const handleInsertInput = async () => {
    const inputMaster = "#INPUT#";
    const textarea: any = defaultValueRef.current;
    const { selectionStart, selectionEnd }: any = textarea;
    const newText =
      fieldValue.substring(0, selectionStart) +
      inputMaster +
      fieldValue.substring(selectionEnd);
    setFieldValue(newText);
    textarea.focus();
  };

  useEffect(() => {
    if (!template?.sections) {
      return;
    }
    const initSections = template.sections.items
      .filter(
        (section: any) =>
          (section.isSimple === false || section.isSimple === null) &&
          section?.subsections?.items.length > 0 &&
          section.name
      )
      ?.map((section: any) => {
        return { value: section.id, label: section.name };
      });
    if (initSections && initSections.length > 0) {
      setSections(initSections);
      setSectionId(initSections[0].value);
    }
  }, [template]);

  useEffect(() => {
    if (!template?.sections || !sectionId) {
      return;
    }
    if (modalOpened) {
      const sectionDetail = template?.sections?.items.find(
        (section: any) => section.id == sectionId
      );
      const lstSubsection = sectionDetail?.subsections?.items
        ?.filter((subsection: any) => subsection.name)
        ?.map((subs: any) => {
          return { value: subs.id, label: subs.name };
        });

      if (lstSubsection && lstSubsection.length > 0) {
        setSubSectionId(lstSubsection[0]?.value);
        setSubsections(lstSubsection);
      } else {
        setSubSectionId("");
        setSubsections(null);
      }
    }
  }, [sectionId, modalOpened]);

  useEffect(() => {
    if (field?.id) {
      setFieldName(field.name);
      setFieldValue(field.value);
      setSectionId(field.sID);
      setSubSectionId(field.ssID);
      console.log({ field });
    }
  }, [field]);

  const handleEditField = async () => {
    if (
      fieldName === "" ||
      fieldValue === "" ||
      sectionId === "" ||
      subSectionId === ""
    ) {
      setErrorMsg(
        "Please provide a name, default value, section, and subsection"
      );
      return;
    }
    setErrorMsg("");
    setIsLoading(true);

    try {
      const updateFieldInput: UpdateTemplateFieldInput = {
        id: field.id,
        _version: field._version,
        name: fieldName,
        value: fieldValue,
        ssID: subSectionId
      };

      const updateFieldInputVars: UpdateTemplateFieldMutationVariables = {
        input: updateFieldInput
      };

      const updateFieldResponse = await client.graphql<
        GraphQLQuery<UpdateTemplateFieldMutation>
      >({ query: updateTemplateField, variables: updateFieldInputVars });
      console.log(updateFieldResponse);
      fetchTemplate(template.id);
    } catch (err) {
      console.log("error editing field:", err);
    }
    setIsLoading(false);
    closeAndResetModal();
  };

  const handleDeleteField = async () => {
    try {
      setIsLoading(true);
      // dispatch(setIsRefreshing());
      const deleteFieldInput: DeleteTemplateFieldInput = {
        id: field.id,
        _version: field._version
      };

      const deleteFieldInputVars: DeleteTemplateFieldMutationVariables = {
        input: deleteFieldInput
      };

      const deleteFieldResult = await client.graphql<
        GraphQLQuery<DeleteTemplateFieldMutation>
      >({ query: deleteTemplateField, variables: deleteFieldInputVars });
      console.log(deleteFieldResult);
      fetchTemplate(template.id);
    } catch (err) {
      console.log("error deleting field:", err);
    }
    setIsLoading(false);
    closeAndResetModal();
  };

  const closeAndResetModal = () => {
    setModalOpened(false);
    setErrorMsg("");
    // setFieldName("");
    // setFieldValue("");
    // setSubSectionId("");
    // setSubsections(null);
  };
  return (
    <Modal opened={modalOpened} onClose={closeAndResetModal} title="Edit field">
      <TextInput
        label="Name"
        placeholder="Enter field name"
        value={fieldName}
        onChange={(event) => setFieldName(event.target.value)}
        required
      />
      <Flex flex={1} align={"center"} justify={"space-between"}>
        <Text>Default value</Text>
        <Button variant="transparent" p={0} onClick={handleInsertInput}>
          Insert input
        </Button>
      </Flex>
      <Textarea
        label=""
        ref={defaultValueRef}
        placeholder="Enter default value"
        value={fieldValue}
        rows={4}
        onChange={(event) => setFieldValue(event.target.value)}
        autosize
        resize="vertical"
      />
      {errorMsg && (
        <Text fz={14} fw={400} c={"red"}>
          {errorMsg}
        </Text>
      )}
      <Select
        placeholder="Select section"
        label="Section"
        data={sections}
        value={sectionId}
        onChange={(_value, option) => setSectionId(option.value)}
      />
      <Select
        placeholder="Select subsection"
        label="Subsection"
        data={subSections}
        value={subSectionId}
        onChange={(_value, option) => setSubSectionId(option.value)}
      />

      <Group mt="md">
        <Group mt="md">
          <Button
            disabled={isLoading}
            loading={isLoading}
            onClick={handleEditField}
          >
            Save
          </Button>
          <Button
            disabled={isLoading}
            color="red"
            loading={isLoading}
            onClick={handleDeleteField}
          >
            Delete
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default EditFieldTemplateModal;
